module.exports = __webpack_public_path__ + "img/kknn01.f2785196.jpg";